import {
    useDeleteMultiFormDataMutation,
    useGetMultiFormDataQuery,
} from "modules/pvs_activities/redux/service/formData";
import React, { useContext, useRef } from "react";
import { FormDataContext } from "../contexts/FormContext";
import { displayNotification } from "helpers";
import DropdownMenu from "../DropdownMenu";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import TableElementModifyDataentryModal from "./modals/TableElementModifyDataentryModal";
import DOMPurify from 'dompurify';
const TableBodyDataentry = (props) => {
    const editModalRefs = useRef([]);
    const formDataContext = useContext(FormDataContext);
    const formDataRes = useGetMultiFormDataQuery({
        sectionId: formDataContext.sectionId,
        movementId: formDataContext.movementId,
        elementId: props.tableId,
    });
    const [deleteMultiFormData] = useDeleteMultiFormDataMutation();

    if (formDataRes.isLoading) {
        return (
            <tr>
                <td className="text-center" colSpan={props.columns.length + 2}>
                    Loading...
                </td>
            </tr>
        );
    }

    if (formDataRes.isError) {
        displayNotification("error", "Error loading table data");
        console.log({ error: formDataRes.error });
        return (
            <tr>
                <td className="text-center" colSpan={props.columns.length + 2}>
                    Error Loading Data. Please refresh the page.
                </td>
            </tr>
        );
    }

    const handleDelete = (rowRef) => {
        if (window.confirm("You are about to delete a record. Are you sure?")) {
            deleteMultiFormData(rowRef);
        }
    };

    const createMarkup = (html) => { return { __html: DOMPurify.sanitize(html) }; };
    return (
        <>
            {formDataRes.isSuccess &&
                (Object.values(formDataRes.data).length > 0 ? (
                    Object.entries(formDataRes.data).map(([ks, rs], key) => (
                        <tr key={ks}>
                            <td className="text-center">{key + 1}</td>
                            {props.columns.map((c, k) => (
                                // <td key={k}>{rs[c.id]?.content}</td>
                                <td key={k} dangerouslySetInnerHTML={createMarkup(rs[c.id]?.content)} />
                               
                            ))}
                            {props.isReadOnly === false && (
                                <td>
                                    <DropdownMenu
                                        items={[
                                            {
                                                icon: <FaPencilAlt />,
                                                text: "Edit",
                                                onClick: () => editModalRefs.current[key].openModal(),
                                            },
                                            {
                                                icon: <FaTrash />,
                                                text: "Delete",
                                                onClick: () => handleDelete(ks),
                                            },
                                        ]}
                                    />
                                    <TableElementModifyDataentryModal
                                        ref={(ref) => (editModalRefs.current[key] = ref)}
                                        mode="edit"
                                        display="none"
                                        id={ks}
                                        templateId={props.templateId}
                                        tableId={props.tableId}
                                        columns={props.columns}
                                    />
                                </td>
                            )}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td className="text-center" colSpan={props.columns.length + 2}>
                            No Data Found
                        </td>
                    </tr>
                ))}
        </>
    );
};

TableBodyDataentry.defaultProps = {
    templateId: "",
    tableId: "",
    columns: [],
    isReadOnly: false,
};

export default TableBodyDataentry;
